export default {
	"11cf0b7b5c6a61c5511eba645594c1bb": "沒有檢測到支付結果",
	"07b0bca0c86195467d293061e8132870": "若已支付請點擊刷新進行結果查詢",
	"2396ccabf52cb680fb975e1f849f9f02": "刷新",
	"cabd57357355e6d6c246880542cf7910": "重新支付"
}
